import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetHolidays = createModule({
    base: 'GET_HOLIDAYS', apiDetails: {...SERVICE_ENDPOINT.HOLIDAY, method: 'get'}
})

const AddHoliday = createModule({
    base: 'ADD_HOLIDAY', apiDetails: {...SERVICE_ENDPOINT.HOLIDAY, method: 'post'}
})

const UpdateHoliday = createModule({
    base: 'UPDATE_HOLIDAY', apiDetails: {...SERVICE_ENDPOINT.HOLIDAY, method: 'put'}
})

const DeleteHoliday = createModule({
    base: 'DELETE_HOLIDAY', apiDetails: {...SERVICE_ENDPOINT.HOLIDAY, method: 'delete'}
})

const BulkUploadHoliday = createModule({
    base: 'BULK_UPLOAD_HOLIDAY', apiDetails: {...SERVICE_ENDPOINT.HOLIDAY, url: `${SERVICE_ENDPOINT.HOLIDAY.url}/bulk_upload`, method: 'post'}
})

const GetHolidaySheet = createModule({
    base: 'GET_HOLIDAY_SHEET', apiDetails: {...SERVICE_ENDPOINT.HOLIDAY, url: `${SERVICE_ENDPOINT.HOLIDAY.url}/download_sheet`, method: 'get'}
})

export {
    GetHolidays, AddHoliday, UpdateHoliday, DeleteHoliday,BulkUploadHoliday,GetHolidaySheet
}